export type COLOR_MODE = 'COLOR_MODE_AUTO' | 'COLOR_MODE_LIGHT' | 'COLOR_MODE_DARK';
export const COLOR_MODE_AUTO: COLOR_MODE = 'COLOR_MODE_AUTO';
export const COLOR_MODE_LIGHT: COLOR_MODE = 'COLOR_MODE_LIGHT';
export const COLOR_MODE_DARK: COLOR_MODE = 'COLOR_MODE_DARK';
export const COLOR_MODES: readonly COLOR_MODE[] = Object.freeze([COLOR_MODE_AUTO, COLOR_MODE_LIGHT, COLOR_MODE_DARK]);

// http://chir.ag/projects/name-that-color/
export type color = string;
export const CERULEAN: color = '#0AA5CC';
export const HELIOTROPE: color = '#AC4DFF'; // Nucleus Brand
export const MALACHITE: color = '#0ABF64';
export const MEDIUM_RED_VIOLET: color = '#BF2AA7';
export const ROYAL_BLUE: color = '#4072E6';
export const TUNDORA: color = '#4D4D4D';
export const WATTLE: color = '#DBC540';

export interface theme {
  id: string;
  value: color;
}
export const STANDARD_COLOR_DEFAULT: color = HELIOTROPE;
export const STANDARD_COLOR_THEMES: Array<theme> = [
  { id: 'ROYAL_BLUE', value: ROYAL_BLUE },
  { id: 'MEDIUM_RED_VIOLET', value: MEDIUM_RED_VIOLET },
  { id: 'MALACHITE', value: MALACHITE },
  { id: 'TUNDORA', value: TUNDORA },
];
